/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { VisualFilterModel } from '@/api/types/browse-search-types';
import type { FilterDataType, HandleFilterType } from '../../../types/filterTypes';

export const getVisualFilters = ({
  filter,
  visualFilters,
}: {
  filter: FilterDataType;
  visualFilters?: VisualFilterModel[]; // from product-shelves response
}): HandleFilterType[] => {
  const { displayName, dimensionName, quickFilter } = filter;

  const matchingVisualFilter = visualFilters?.find(
    (facet: VisualFilterModel) =>
      facet.facetInternalName === filter?.dimensionName && filter.dimensionName !== undefined,
  );

  return (
    matchingVisualFilter?.facetValues
      ?.map((matchingFacet) => {
        const { facetValueDisplayName, imageUrl } = matchingFacet;

        const refinement = filter.refinements.find(
          (refinement) => refinement.label === facetValueDisplayName,
        );

        if (refinement) {
          return {
            refinement,
            displayName,
            dimensionName,
            quickFilter,
            imageUrl,
          } as HandleFilterType;
        }
        return null;
      })
      .filter((item): item is HandleFilterType => item !== null) ?? []
  );
};
